<template>
  <main :class="['d-flex flex-grow-1 bg-white', { 'bg-lg-primary': !isAdmin }]">
    <section class="container py-3 py-sm-4">
      <div :class="['col-12 px-0 mx-auto', { 'col-dialog': !isAdmin }]">
        <form class="needs-validation bg-white rounded py-3 p-lg-4" @submit.prevent="register" novalidate>
          <h1 :class="['mb-3 mb-sm-4', isAdmin ? success ? 'h2 text-center' : 'h2' : 'h3 pb-3 pb-sm-4 border-bottom text-center']">{{ success ? 'Thank You' : 'Register Member for Campdraft One' }}</h1>
          <div v-if="!success">

            <div role="alert" class="alert alert-warning d-flex justify-content-between align-items-center" v-if="errors">
              {{errors}}
              <router-link v-if="responseStatus === 'email_exists' && !isAdmin" tag="button" class="btn btn-primary" to="/login">Sign in</router-link>
            </div>

            <existing-member v-if="existingMember === true" @input="password = $event" class="mb-3" />
            <new-member :errors="errors" :errorStatus="errorStatus" :responseStatus="responseStatus" :isAdmin="isAdmin" v-else @input="password = $event" @userInfo="userInfo = $event" @newMember="newMember = $event"  />

            <div :class="['form-group form-check px-0 mb-sm-4', { 'sr-only': isAdmin }]" v-if="newMember">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="terms" required v-model="terms">
                <label class="custom-control-label" for="terms">
                  In consideration for me, and/or minors in my care, being allowed to participate in all events run by the Australian Campdraft Association Inc. (ACA), I hereby agree that I have permission to accept the membership waiver, on behalf of all persons for whom this membership is for, a full copy of which is available on the ACA website and the membership tax invoice.
                </label>
                <div class="invalid-tooltip">Please agree to the membership waiver.</div>
              </div>
            </div>
            <div class="d-flex justify-content-sm-between flex-wrap">
              <div class="mb-2 my-sm-auto order-1 order-lg-0" v-if="!isAdmin">
                Already have an ACA account?
                <router-link tag="a" to="/login">Sign in</router-link>.
              </div>
              <button type="submit" v-if="newMember" class="btn btn-primary btn-block-mob mb-3 mb-lg-0 ml-lg-auto" @click="handleSubmit"
                :disabled="loading"
              >Register</button>
            </div>
          </div>
          <div v-else-if="!isAdmin" class="text-center">
            <p>Please check your email <span class="text-primary" v-if="userInfo.email !== ''">{{userInfo.email}}</span> for a welcome message from us.</p>
            <div>Back to <router-link tag="a" to="/login">Sign in</router-link>.</div>
          </div>
          <div v-else class="text-center">
            <p>The user with email <span class="text-primary" v-if="userInfo.email !== ''">{{userInfo.email}}</span> has been created successfully.</p>
          </div>
        </form>
      </div>
    </section>

  </main>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import registerExisting from './RegisterExisting'
import registerNew from './RegisterNew'

export default {
  name: 'Register',
  props: ['isAdmin'],
  components: {
    'existing-member': registerExisting,
    'new-member': registerNew
  },
  mixins: [HANDLESUBMIT],
  data() {
    return {
      loading: false,
      success: false,
      errors: '',
      errorStatus: '',
      responseStatus: '',
      existingMember: false,
      userInfo: {},
      terms: this.isAdmin,
      newMember: this.isAdmin
    }
  },
  methods: {
    register(event) {
      event.preventDefault()
      const file = event.target.elements.proofOfAge.files[0]
      if (file && file.size > 1024 * 1024) {
        this.success = ''
        this.errorStatus = 'file'
        this.errors = `The Proof of Age file may not be greater than 1 mb.`
      }
      const fields = event.target.elements
      // eslint-disable-next-line
      const data = {
        dob: fields.dateOfBirth.value,
        gender: fields.gender.value,
        rider_status: fields.riderStatus.value,
        boy_status: fields.boyStatus.value,
        title: fields.title.value,
        first_name: fields.firstName.value,
        last_name: fields.lastName.value,
        email: fields.email.value,
        phone: fields.phone.value,
        mobile_phone: this.userInfo.mobile_phone || null,
        carbon_copy_mobile: this.userInfo.carbon_copy_mobile || null,
        street_1: fields.address.value,
        street_2: fields.address2.value,
        suburb: fields.suburb.value,
        postcode: fields.postcode.value,
        state: fields.state.value,
        terms: this.terms,
        role: this.isAdmin ? fields.role.value : 'member',
        zone: fields.zone.value || null,
        password: fields.password.value,
        password_confirmation: fields.confirmPassword.value
      }

      if (this.isAdmin) {
        data.member_number = fields.memberNumber !== undefined ? fields.memberNumber.value : ''
        data.notes = fields.notes.value
      }
      this.loading = true

      const formData = new FormData()
      formData.append('file', file)
      formData.append('fields', JSON.stringify(data))
      axios.post(`${this.$api}/auth/register-new`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          // Success
          this.responseStatus = response.data.status
          if (response.data.status === 'success') {
            // Show next screen telling them to check their email
            this.errors = ''
            this.success = true
          } else {
            this.success = false
            this.loading = false
          }
          // Validation Error
          if (response.data.status === 'validation_error') {
            if (response.data.errors.dob) {
              // DoB
              this.errorStatus = 'validation_error'
              this.errors = 'Please include your Date of Birth.'
            } else if (response.data.errors.member_number) {
              this.errorStatus = 'member_number'
              this.errors = 'The member number has already been taken.'
            } else if (response.data.errors.mobile_phone) {
              this.errorStatus = 'mobile_phone'
              this.errors = 'Please include correct mobile phone number.'
            } else if (response.data.errors.file) {
              this.errorStatus = 'file'
              this.errors = 'The Proof of Age file may not be greater than 1 mb.'
            } else if (response.data.errors.carbon_copy_mobile) {
              this.errorStatus = 'carbon_copy_mobile'
              this.errors = 'Please include correct CC mobile.'
            } else if (response.data.errors.email) {
              // Email
              this.errorStatus = 'email'
              if (response?.data?.errors?.email[0]) {
                this.errors = response.data.errors.email[0]
              } else {
                this.errors = 'Please include correct email address.'
              }
            } else {
              // response.data.errors will contain array of error fields
              this.errors = 'Please ensure all fields are completed.'
            }
            if (response.data.errors.phone) {
              this.errors += ' Either the Phone or Mobile Phone Numbers is required.'
            }
          }
          // Email already registered, please log in
          if (response.data.status === 'email_exists') {
            // Please log in
            this.errors = `An account exists with this email address.${this.isAdmin ? '' : ' Please Sign In.'}`
          }
          // Something went wrong
          if (response.data.status === 'registration_error' || response.data.status === 'undefined_error') {
            // Alert - Something went wrong, please try again later
            this.errors = 'There was a server error. Please try again later.'
          }
          // if the request data are invalid
          if (response?.data?.status === 'invalid_data' && response?.data?.message) {
            this.errors = response?.data?.message
          }
        })
    }
  },
  watch: {
    userInfo: {
      handler() {
        this.errors = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.col-dialog {
  flex: 0 1 897px;
  max-width: 897px;
}
</style>



// WEBPACK FOOTER //
// src/views/Account/Register.vue